import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { adminGetDriverDetailsByLicense, adminAddDriver } from '../services/Api'
import { validateLicenseFormat } from '../services/Function'
import { ToastContainer, toast } from 'react-toastify';

const AddDriver = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const driverData = location.state?.driverData
  const driverId = location.state?.driverId
  console.log(driverId)

  // State management
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [verifyDriverDetails, setVerifyDriverDetails] = useState(false)
  const [verifyLoading, setVerifyLoading] = useState(false)
  const [dob, setDob] = useState(new Date())
  const [showConsent, setShowConsent] = useState(false)
  const [formValues, setFormValues] = useState({
    driver_name: "",
    driver_aadhar: null,
    driver_image: null,
    driver_mobile_number: "",
    driver_address: "",
    driver_license_number: "",
    driver_dob: new Date()
  })

  // Initialize form with driver data if editing
  useEffect(() => {
    if (driverData) {
      setFormValues({
        driver_name: driverData?.driver_name || "",
        driver_aadhar: driverData?.driver_aadhar || null,
        driver_image: driverData?.driver_image || null,
        driver_mobile_number: driverData?.driver_mobile_number || "",
        driver_address: driverData?.driver_address || "",
        driver_license_number: driverData?.driver_license_number || "",
        driver_dob: driverData?.driver_dob || new Date()
      })
      setVerifyDriverDetails(true)
    }
  }, [driverData])


  // Handle file upload
  const handleFileUpload = (field, file) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      const fileData = {
        name: file.name,
        type: file.type,
        data: e.target.result,
        file: file
      }
      setFormValues(prev => ({
        ...prev,
        [field]: fileData
      }))
    }
    reader.readAsDataURL(file)
  }

  // Validate mobile number
  const validateMobileNumber = (mobile) => {
    const mobileRegex = /^[6-9]\d{9}$/
    return mobileRegex.test(mobile)
  }

  // Get driver details by license
  const getDriverDetailsByLicense = async () => {
    try {
      if (!formValues?.driver_license_number || !validateLicenseFormat(formValues?.driver_license_number)) {
        console.log('Enter valid license number')
        toast.error('Enter valid license number')
        return
      }

      if ((new Date().getFullYear() - dob.getFullYear()) < 18) {
        toast.error('Driver must be 18 years old')
        return
      }

      setVerifyLoading(true)
      try {
        const response = await adminGetDriverDetailsByLicense({
          license_number: formValues?.driver_license_number,
          dob: dob.toISOString().split('T')[0]
        })

        const driverData = response?.data?.data
        setFormValues({
          driver_name: driverData?.name || "",
          driver_dob: driverData?.dob || "",
          driver_address: driverData?.permanent_address || "",
          driver_mobile_number: "",
          driver_image: null,
          driver_aadhar: null,
          driver_license_number: formValues?.driver_license_number || "",
        })
        setVerifyDriverDetails(true)
        toast.success('Driver details verified successfully!')
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to verify driver details. Please try again.')
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to verify driver details. Please try again.')
    } finally {
      setVerifyLoading(false)
    }
  }

  // Handle form submission
  const handleSubmit = async () => {
    try {
      setIsSubmitting(true)

      const formData = new FormData()

      formData.append("user_id", driverId)
      formData.append("by_admin", true)
      formData.append("driver_name", formValues.driver_name.trim())
      formData.append("driver_mobile_number", formValues.driver_mobile_number.trim())
      formData.append("driver_address", formValues.driver_address?.trim())
      formData.append("driver_license_number", formValues.driver_license_number.trim())
      formData.append("driver_dob", formValues.driver_dob)


      // Add Aadhaar image if available
      if (formValues.driver_image?.file) {
        formData.append("driver_image", formValues.driver_image.file)
      }

      if (formValues.driver_aadhar?.file) {
        formData.append("driver_aadhar", formValues.driver_aadhar.file)
      }

      const response = await adminAddDriver(formData)
      toast.success(response?.data?.message || 'Driver saved successfully!')
      setShowConsent(false)

      // Navigate back or to drivers list
      setTimeout(() => {
        navigate(-1) // Go back to previous page
      }, 12000)

    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to save driver. Please try again.')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <>
      < ToastContainer />
      <div className="bg-gray-100 min-h-screen py-8 px-4 sm:px-6 lg:px-8">
        <button className="flex items-center w-fit bg-[#E53935] px-2 py-1 rounded-md active:scale-95 duration-500" onClick={() => navigate(-1)}>
          <svg width="20" height="20" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5516 21.3393H30.2057C30.6543 21.3393 31.0304 21.1875 31.3339 20.8841C31.6373 20.5806 31.7891 20.2045 31.7891 19.7559C31.7891 19.3073 31.6373 18.9313 31.3339 18.6278C31.0304 18.3243 30.6543 18.1726 30.2057 18.1726H12.5516L17.0641 13.6601C17.3807 13.3434 17.5325 12.974 17.5193 12.5518C17.5061 12.1295 17.3543 11.7601 17.0641 11.4434C16.7474 11.1268 16.3714 10.9618 15.9359 10.9486C15.5005 10.9354 15.1245 11.0872 14.8078 11.4038L7.56406 18.6476C7.40573 18.8059 7.29358 18.9775 7.2276 19.1622C7.16163 19.3469 7.12865 19.5448 7.12865 19.7559C7.12865 19.967 7.16163 20.165 7.2276 20.3497C7.29358 20.5344 7.40573 20.7059 7.56406 20.8643L14.8078 28.108C15.1245 28.4247 15.5005 28.5764 15.9359 28.5632C16.3714 28.55 16.7474 28.3851 17.0641 28.0684C17.3543 27.7518 17.5061 27.3823 17.5193 26.9601C17.5325 26.5379 17.3807 26.1684 17.0641 25.8518L12.5516 21.3393Z" fill="white" />
          </svg>
          <button className="">
            <span className=" text-white ms-1">Back</span>
          </button>
        </button>
        <div className="max-w-2xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-center text-red-600 mb-2">
              {driverData ? 'Edit Driver Details' : 'Add New Driver'}
            </h1>
            <p className="text-center text-gray-600">Enter driver information to register</p>
          </div>

          {verifyDriverDetails ? (
            /* Driver Details Form */
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="space-y-6">
                {/* Header with back button */}
                {!driverData && (
                  <div className="flex justify-end">
                    <button
                      onClick={() => setVerifyDriverDetails(false)}
                      className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors"
                    >
                      Enter Different License
                    </button>
                  </div>
                )}

                {/* Driver Name */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Full Name
                  </label>
                  <input
                    type="text"
                    value={formValues.driver_name || ""}
                    readOnly
                    className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                    placeholder="Driver Name"
                  />
                </div>

                {/* Driver License */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Driver License
                  </label>
                  <input
                    type="text"
                    value={formValues.driver_license_number || ""}
                    readOnly
                    className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                    placeholder="Driver License Number"
                  />
                </div>

                {/* Mobile Number */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Mobile Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    value={formValues.driver_mobile_number || ""}
                    onChange={(e) => setFormValues({ ...formValues, driver_mobile_number: e.target.value })}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                    placeholder="Enter mobile number"
                    maxLength={10}
                  />
                </div>

                {/* Date of Birth */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Date of Birth
                  </label>
                  <input
                    type="text"
                    value={formValues.driver_dob || ""}
                    readOnly
                    className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                    placeholder="Date of Birth"
                  />
                </div>

                {/* Address */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Address
                  </label>
                  <textarea
                    value={formValues.driver_address || ""}
                    onChange={(e) => setFormValues({ ...formValues, driver_address: e.target.value })}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                    placeholder="Enter address"
                    rows={3}
                  />
                </div>

                {/* Aadhaar Card Upload */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Aadhaar Card Image <span className="text-red-500">*</span>
                  </label>
                  {formValues.driver_aadhar ? (
                    <div className="relative">
                      <img
                        src={formValues.driver_aadhar.data}
                        alt="Aadhaar Card"
                        className="w-full h-48 object-cover rounded-lg border"
                      />
                      <div className="absolute top-2 right-2 flex gap-2">
                        <button
                          onClick={() => document.getElementById('aadhaar-input').click()}
                          className="bg-blue-600 text-white p-2 rounded-full hover:bg-blue-700"
                        >
                          ✏️
                        </button>
                        <button
                          onClick={() => setFormValues({ ...formValues, driver_aadhar: null })}
                          className="bg-red-600 text-white p-2 rounded-full hover:bg-red-700"
                        >
                          🗑️
                        </button>
                      </div>
                      <input
                        id="aadhaar-input"
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={(e) => {
                          const file = e.target.files[0]
                          if (file) handleFileUpload('driver_aadhar', file)
                        }}
                      />
                    </div>
                  ) : (
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                      <input
                        id="aadhaar-input"
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={(e) => {
                          const file = e.target.files[0]
                          if (file) handleFileUpload('driver_aadhar', file)
                        }}
                      />
                      <button
                        onClick={() => document.getElementById('aadhaar-input').click()}
                        className="bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors"
                      >
                        📄 Upload Aadhaar Card
                      </button>
                    </div>
                  )}
                </div>
                {/* Driver Image Upload */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Driver Image <span className="text-red-500">*</span>
                  </label>
                  {formValues.driver_image ? (
                    <div className="relative">
                      <img
                        src={formValues.driver_image.data}
                        alt="Driver"
                        className="w-full h-48 object-cover rounded-lg border"
                      />
                      <div className="absolute top-2 right-2 flex gap-2">
                        <button
                          onClick={() => document.getElementById('driver-image-input').click()}
                          className="bg-blue-600 text-white p-2 rounded-full hover:bg-blue-700"
                        >
                          ✏️
                        </button>
                        <button
                          onClick={() => setFormValues({ ...formValues, driver_image: null })}
                          className="bg-red-600 text-white p-2 rounded-full hover:bg-red-700"
                        >
                          🗑️
                        </button>
                      </div>
                      <input
                        id="driver-image-input"
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={(e) => {
                          const file = e.target.files[0]
                          if (file) handleFileUpload('driver_image', file)
                        }}
                      />
                    </div>
                  ) : (
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                      <input
                        id="driver-image-input"
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={(e) => {
                          const file = e.target.files[0]
                          if (file) handleFileUpload('driver_image', file)
                        }}
                      />
                      <button
                        onClick={() => document.getElementById('driver-image-input').click()}
                        className="bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors"
                      >
                        📄 Upload Driver Image
                      </button>
                    </div>
                  )}
                </div>
                {/* Submit Button */}
                <button
                  onClick={() => {
                    if (driverData) {
                      handleSubmit()
                    } else {
                      if (!validateMobileNumber(formValues.driver_mobile_number)) {
                        toast.error('Valid mobile number is mandatory')
                        return
                      }
                      setShowConsent(true)
                    }
                  }}
                  disabled={isSubmitting}
                  className="w-full bg-red-600 text-white py-3 rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-semibold"
                >
                  {isSubmitting ? 'Saving...' : (driverData ? 'UPDATE' : 'SAVE')}
                </button>
              </div>
            </div>
          ) : (
            /* License Verification Form */
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="space-y-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">Verify Driver License</h2>

                {/* License Number */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    License Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={formValues.driver_license_number}
                    onChange={(e) => setFormValues({ ...formValues, driver_license_number: e.target.value.toUpperCase() })}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                    placeholder="Enter license number (e.g., AB1234567890)"
                  />
                </div>

                {/* Date of Birth */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Driver DOB (as per document) <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    value={dob.toISOString().split('T')[0]}
                    onChange={(e) => setDob(new Date(e.target.value))}
                    max={new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split('T')[0]}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  />
                </div>

                {/* Verify Button */}
                <button
                  onClick={getDriverDetailsByLicense}
                  disabled={verifyLoading}
                  className="w-full bg-black text-white py-3 rounded-lg hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-semibold"
                >
                  {verifyLoading ? 'Verifying...' : 'Continue'}
                </button>
              </div>
            </div>
          )}

          {/* Consent Modal */}
          {showConsent && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 max-w-md mx-4">
                <h3 className="text-lg font-semibold mb-4">Consent Agreement</h3>
                <p className="text-gray-600 mb-6">
                  By proceeding, you agree to the terms and conditions for adding a driver to your account.
                </p>
                <div className="flex gap-3">
                  <button
                    onClick={() => setShowConsent(false)}
                    className="flex-1 bg-gray-300 text-gray-700 py-2 rounded-lg hover:bg-gray-400 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSubmit}
                    className="flex-1 bg-red-600 text-white py-2 rounded-lg hover:bg-red-700 transition-colors"
                  >
                    Agree & Continue
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default AddDriver